// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_5t-0";
export var orangeButton = "_5t-1";